module.exports = "https://assets.sidelineswap.com/web/_next/static/images/desktop-bg-65e38161422348dedca1a0dc35e55562.jpg";